import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import React, { useState } from "react";

import CustomIcon, { IconName } from "src/components/Icon/Icon";

interface ICollapsibleCardProps {
  title: string;
  iconName: IconName;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

const CollapsibleCard: React.FC<ICollapsibleCardProps> = ({ title, iconName, children, defaultOpen = true }) => {
  const [expanded, setExpanded] = useState(defaultOpen);

  const handleChange = () => {
    setExpanded(prev => !prev);
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange}
      disableGutters
      elevation={0}
      square
      className={`broker-builder__card-wrap ${expanded ? "open" : "collapsed"}`}>
      <AccordionSummary
        expandIcon={
          <span className={`broker-builder__card-chevron-icon ${expanded ? "open" : ""}`}>
            <CustomIcon name={IconName.ChevronDownGold} size="16px" />
          </span>
        }
        sx={{
          padding: 0,
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-expandIconWrapper": {
            transform: "none !important",
          },
        }}>
        <div className="heading4 broker-builder__card-title">
          <CustomIcon name={iconName} size="24px" />
          {title}
        </div>
      </AccordionSummary>
      <AccordionDetails className="broker-builder__card-content" sx={{ padding: 0 }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default CollapsibleCard;
